module.exports = __webpack_public_path__ + "img/fz.5bdf3b1e.jpg";